import React from 'react';
import ReactDOM from 'react-dom';
import AppLayout from './components/Layout/AppLayout';

ReactDOM.render(
  <AppLayout />,
  document.getElementById('betmount')
);
